var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 13.5,
    fill: "#E7E0F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 8,
    cy: 7,
    r: 7,
    fill: "#E7E0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 28C6.43333 28 5.80556 27.7389 5.28333 27.2167C4.76111 26.6945 4.5 26.0667 4.5 25.3333V6.66668C4.5 5.93334 4.76111 5.30557 5.28333 4.78334C5.80556 4.26112 6.43333 4.00001 7.16667 4.00001H12.7667C13.0556 3.20001 13.5389 2.55557 14.2167 2.06668C14.8944 1.57779 15.6556 1.33334 16.5 1.33334C17.3444 1.33334 18.1056 1.57779 18.7833 2.06668C19.4611 2.55557 19.9444 3.20001 20.2333 4.00001H25.8333C26.5667 4.00001 27.1944 4.26112 27.7167 4.78334C28.2389 5.30557 28.5 5.93334 28.5 6.66668V25.3333C28.5 26.0667 28.2389 26.6945 27.7167 27.2167C27.1944 27.7389 26.5667 28 25.8333 28H7.16667ZM7.16667 25.3333H25.8333V6.66668H7.16667V25.3333ZM9.83333 22.6667H19.1667V20H9.83333V22.6667ZM9.83333 17.3333H23.1667V14.6667H9.83333V17.3333ZM9.83333 12H23.1667V9.33334H9.83333V12ZM16.5 5.66668C16.7889 5.66668 17.0278 5.57223 17.2167 5.38334C17.4056 5.19445 17.5 4.95557 17.5 4.66668C17.5 4.37779 17.4056 4.1389 17.2167 3.95001C17.0278 3.76112 16.7889 3.66668 16.5 3.66668C16.2111 3.66668 15.9722 3.76112 15.7833 3.95001C15.5944 4.1389 15.5 4.37779 15.5 4.66668C15.5 4.95557 15.5944 5.19445 15.7833 5.38334C15.9722 5.57223 16.2111 5.66668 16.5 5.66668Z",
    fill: "#873CAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentsIcon);
export default __webpack_public_path__ + "static/media/assessments_icon.36f667c0322476a1790e9399de748ecb.svg";
export { ForwardRef as ReactComponent };